module.exports = __webpack_public_path__ + "static/assets/7c201a8a56bb6ac6708b60ee668b90fe.svg";